<script lang="ts">
    import { onMount, createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    import type { GatewayPublicInfo } from '../../../modules/paymentsApi/gateways/gateway.entity'
    import type { Purchase } from '../../../modules/paymentsApi/purchases/purchase.entity'
    import ComponentCard from './component-card.svelte'
    import { AssignNewCardDto } from '../../../modules/paymentsApi/customer-cards/dto/assign-new-card.dto'
    export let purchaseId: string

    let gateway: GatewayPublicInfo = null
    let err: { title: string; message: string; code: string; retry: boolean } = null
    let purchase: Purchase = null
    let card: AssignNewCardDto = new AssignNewCardDto()

    let step = 0
    onMount(async () => {
        await loadPage()
    })

    async function loadPage() {
        if (!purchaseId) {
            step = 10
            err = {
                title: 'Link inválido',
                message: 'ID da compra não informado.',
                code: 'no-purchaseid',
                retry: false,
            }
            return
        }
        purchase = await window.api.payments.purchases.getOnePublic(purchaseId)
        gateway = await window.api.payments.gateways.getOnePublic(purchase.gatewayId)
        console.log('purchase', purchase)
        console.log('gateway', gateway)
        dispatch('load', gateway)
        step = 1
    }

    function setBrand(brand: string) {
        card.card.brand = brand
    }

    let statusBill: number = 0
    function showProgress(recursive = false) {
        if (!recursive) {
            statusBill = 1
        }
        if (statusBill >= 98 || statusBill === 0) {
            statusBill = 98
            return
        }
        statusBill += (100 - statusBill) * 0.005
        setTimeout(() => showProgress(true), 40)
    }

    async function tryUpdate() {
        showProgress()
        step = 2
        try {
            let result = await window.api.payments.purchases.updateCard(purchaseId, card)
            console.log('result-card-update', result)
            step = 3
        } catch (error) {
            step = 10
            err = {
                title: 'Erro ao tentar atualizar. Verifique os dados do cartão e tente novamente.',
                message: error?.message || error?.text || error?.statusCode || error,
                code: 'card-try-update-error',
                retry: true,
            }
        }
    }
</script>

<div class="checkout">
    {#if step === 0}
        <div class="-box -loading">
            <div class="-line">Carregando...</div>
        </div>
    {/if}
    {#if step === 1}
        <ComponentCard {gateway} bind:card on:success={tryUpdate} />
    {/if}
    {#if step === 2}
        <div class="-box -box-billing">
            <!-- <button on:click={() => (step = 5)}>voltar</button> -->
            <div class="spacer" />
            <div class="-line -padding">
                <div class="-trying">Processando...</div>
            </div>
            <div class="spacer" />
            <div class="-bill-bar-container">
                <div style="width:{statusBill}%;" class="-bill-bar" />
            </div>
        </div>
    {/if}
    {#if step === 3}
        <div class="-box -box-success">
            <div class="spacer" />
            <div class="-line -padding">
                <div class="-success">Sucesso</div>
                <div class="-subtitle">Cartão atualizado</div>
                <div class="-track">{'success'}</div>
            </div>
            <div class="spacer" />
        </div>
    {/if}
    {#if step === 10}
        <div class="-box -box-error">
            <div class="spacer" />
            <div class="-line -padding">
                <div class="-error">{err.title}</div>
                <div class="-subtitle">{err.message}</div>
                <div class="-track">Código: {err.code}</div>
            </div>
            <div class="spacer" />
            {#if err.retry}
                <div class="-line -inline acts">
                    <button on:click={() => (step = 1)}>Voltar</button>
                    <div class="spacer" />
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
</style>
